import createUrlBuilder from 'utilities/url.builder.utils';
import {
  getRequest,
  postRequest,
  deleteRequest,
  patchRequest
} from 'utilities/service.utils';
import AppService from './app.service.context';
import { UserSearchParams, ImpersonateUserState } from 'types';

export const fetchUser = async () => {
  const urlBuilder = createUrlBuilder('/community/users/me');
  const result = await getRequest(AppService, urlBuilder.toString());
  return result;
};

export const patchUserDetails = async (payload: any) => {
  const urlBuilder = createUrlBuilder('/community/users/me');
  const response = await patchRequest(
    AppService,
    urlBuilder.toString(),
    payload
  );
  return response;
};

export const fetchUserBySearchTerm = async (param: UserSearchParams) => {
  const urlBuilder = createUrlBuilder(
    `/community/users?fields=*&filter=${param.searchBy}:%25${encodeURIComponent(
      param.search
    )}%25`
  ).toString();
  const result = urlBuilder && (await getRequest(AppService, urlBuilder));
  return result;
};

export const fetchImpersonateUser = async (
  userId: number,
  organisationId: number | undefined = undefined
) => {
  const query = organisationId ? `?organisationId=${organisationId}` : '';
  const urlBuilder = createUrlBuilder(
    `/community/users/${userId}/impersonate${query}`
  ).toString();
  const result: ImpersonateUserState =
    urlBuilder && (await postRequest(AppService, urlBuilder));
  return result;
};

export const fetchApiKeysById = async () => {
  const urlBuilder = createUrlBuilder(`/community/auth/apikeys`);
  return await getRequest(AppService, urlBuilder?.toString());
};

export const generateApiKeyForUser = async () => {
  const urlBuilder = createUrlBuilder(`/community/auth/apikeys`);
  return await postRequest(AppService, urlBuilder?.toString());
};

export const deleteApiKeyForUser = async (apiKeyId: string) => {
  const urlBuilder = createUrlBuilder(`/community/auth/apikeys/${apiKeyId}`);
  return await deleteRequest(AppService, urlBuilder?.toString());
};

export const authenticatedSupportService = async (payload: any) => {
  const urlBuilder = createUrlBuilder(`/system/support/tickets`);
  return await postRequest(AppService, urlBuilder?.toString(), payload);
};

export const unAuthenticatedSupportService = async (payload: any) => {
  const urlBuilder = createUrlBuilder(`/system/support/tickets/anonymous`);
  return await postRequest(AppService, urlBuilder?.toString(), payload);
};

// Temporary block - need to delete after Helix enabled
export const checkRemedyForceUser = async () => {
  const urlBuilder = createUrlBuilder(`/system/remedyForce/client`);
  return await getRequest(AppService, urlBuilder?.toString());
};
// Temporary block
